const initQuantitySubtotal = () => {
    const sectionEls = document.querySelectorAll('.main-product-two')[0];

    const sectionId = sectionEls.getAttribute('data-section');
    const qtyInput = document.getElementById(`Quantity-${sectionId}`);
    const subtotalEl = document.getElementById(`Subtotal-${sectionId}`);

    if (!qtyInput || !subtotalEl) return;

    const formatMoney = (cents) => {
        return '$' + (cents / 100).toFixed(2).replace('.00', '');
    };

    const updateSubtotal = () => {
        const price = parseFloat(subtotalEl.getAttribute('data-price'));
        const qty = parseInt(qtyInput.value) || 1;
        const total = price * qty;

        subtotalEl.innerText = formatMoney(total);
    };

    // Native input events
    qtyInput.addEventListener('change', updateSubtotal);
    qtyInput.addEventListener('input', updateSubtotal);

    // Custom +/- buttons support
    const wrapper = qtyInput.closest('quantity-input');
    if (wrapper) {
        const buttons = wrapper.querySelectorAll('button');
        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                setTimeout(updateSubtotal, 50);
            });
        });
    }

    // Initial calculation
    updateSubtotal();
    
};

// Bind via blObjects
window.blObjects.runFunction(initQuantitySubtotal);
